import React, { createContext, useContext, useState, useEffect } from 'react'
import { THEMES, STORAGE_KEYS } from '../utils/constants'

const ThemeContext = createContext({})

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Check localStorage
    const saved = localStorage.getItem(STORAGE_KEYS.THEME)
    if (saved) return saved

    // Check system preference
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return THEMES.DARK
    }

    return THEMES.LIGHT
  })

  useEffect(() => {
    const root = window.document.documentElement

    // Remove old theme class
    root.classList.remove(THEMES.LIGHT, THEMES.DARK)

    // Add new theme class
    root.classList.add(theme)

    // Save to localStorage
    localStorage.setItem(STORAGE_KEYS.THEME, theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme(prevTheme => 
      prevTheme === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT
    )
  }

  const setLightTheme = () => setTheme(THEMES.LIGHT)
  const setDarkTheme = () => setTheme(THEMES.DARK)

  const value = {
    theme,
    isDark: theme === THEMES.DARK,
    isLight: theme === THEMES.LIGHT,
    toggleTheme,
    setLightTheme,
    setDarkTheme
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeContext
